import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class Destroyable implements OnDestroy {
    
    protected readonly _destroyed$ = new Subject();

    ngOnDestroy(): void{
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}